export const isServer = (): boolean => {
  try {
    return typeof window === "undefined";
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return true;
  }
};
